export default class PrefPresetCard {
  constructor({ elm, app }) {
    this.elm = elm;
    this.app = app;
    this.elm.addEventListener('click', () => {
      this.app.prefPresetCards.forEach((card) => {
        card.elm.classList.remove(this.app.activeClassName);
      });
      this.active();
      return false;
    });
  }

  active() {
    this.elm.classList.add(this.app.activeClassName);
  }

  inactive() {
    this.elm.classList.remove(this.app.activeClassName);
  }
}
